export default "__VITE_ASSET__4b178115__"